// extracted by mini-css-extract-plugin
module.exports = {"container":"breadcrumbs_container__ZgG1t","breadcrumb":"breadcrumbs_breadcrumb__1gDzc","backButton":"breadcrumbs_backButton__3gjY8"};